import React from 'react'

import { ApiErrorMessage } from './api_error_message'

type Props = {
  list: any
}

export const ApiErrorMessages = ({ list }: Props) => {
  return list.map((item: any) => {
    const { httpMethod, route, uniqueKey } = item
    return <ApiErrorMessage key={httpMethod + route + uniqueKey} {...item} />
  })
}
